import { inject, Injectable } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { CloseDialog, OpenDialog, OpenUrl } from './amautas-subscription.actions';
import { AmautasSubscriptionDialogState } from './amautas-subscription.state';

@Injectable({
  providedIn: 'root'
})
export class AmautasSubscriptionDialogFacade {
  private readonly store = inject(Store);

  @Select(AmautasSubscriptionDialogState.open) open$: Observable<boolean>;

  openDialog() {
    this.store.dispatch(new OpenDialog());
  }

  closeDialog() {
    this.store.dispatch(new CloseDialog());
  }

  openUrl() {
    this.store.dispatch(new OpenUrl());
  }
}
